import { useCallback, useEffect, useState } from 'react';
import Modal from '@scalero-inc/forno-modal';
import Button from '@scalero-inc/forno-button';
import { FiCheck, FiExternalLink } from 'react-icons/fi';

import styles from './styles.module.css';

const HELP_CENTER_KEY = 'CANNOLI_HELP_CENTER';

function HelpCenterModal() {
  const [skipMessage, setSkipMessage] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => {
    if (skipMessage) {
      localStorage.setItem(HELP_CENTER_KEY, 'FALSE');
    }
    setIsOpen(false);
  }, [skipMessage]);

  const goToHelpCenter = () => {
    setIsOpen(() => {
      const redirectUrl = `/dashboard/help-center/resources`;
      window.open(redirectUrl, '_blank');
      return false;
    });
  };

  useEffect(() => {
    const showMessage = localStorage.getItem(HELP_CENTER_KEY);
    if (!showMessage) {
      setIsOpen(true);
    }
  }, []);

  return (
    <Modal
      theme="dark"
      isOpen={isOpen}
      onDismiss={close}
      aria-label="help center modal"
    >
      <Modal.Header theme="dark" onDismiss={close} title="Cannoli Support" />
      <p>
        Our support team is reviewing your file. If any errors are found, they
        will fix them and send you a new copy of your file by email shortly.
        <br />
        <br />
        In the meantime, check out our resources at the help center
      </p>
      <Button
        icon={FiExternalLink}
        theme="dark"
        hierarchy="primary"
        onClick={goToHelpCenter}
      >
        Go to help center
      </Button>
      <Modal.Footer>
        <div className={styles['footer-container']}>
          <div
            className={styles['checkbox-container']}
            data-checked={skipMessage}
          >
            <input
              id="help_center"
              type="checkbox"
              className={styles.checkbox}
              onChange={() => setSkipMessage((prevValue) => !prevValue)}
            />
            <FiCheck className={styles['checkbox-check']} size={10} />
            <label htmlFor="help_center">
              Don&#39;t show this message again.
            </label>
          </div>

          <Button theme="dark" hierarchy="secondary" onClick={close}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default HelpCenterModal;
